import React from "react";
import get from "lodash/get";
import { array, bool, number, object, string } from "prop-types";

import CardVideo from "../../atoms/CardVideo";
import NewsHeadline from "../../atoms/NewsHeadline";
import SponsorDetails from "../SponsorDetails";
import Excerpt from "../../atoms/Excerpt";
import StoryMetaData from "../../molecules/StoryMetaData";
import Anchor from "../../atoms/Anchor";

import { getExcerpt } from "../../utils/utils";

import "./newsWithVideo.m.css";

const NewsWithVideo = ({
  story,
  aspectRatio = [3, 2],
  imageType = "image3x2",
  widths = [250, 480, 764],
  showSubHeading = true,
  showExcerpt = false,
  cssStyleName = "",
  autoPlay = 0,
}) => {
  if (!story) return null;

  const excerpt = showExcerpt ? getExcerpt(story) : "";
  const sponsor = get(story, ["metadata", "story-attributes", "sponsoredby", "0", "id"], null);

  const { headline, url } = story;

  return (
    <div styleName="news_with_video" className="news_with_video">
      <Anchor aria-label={headline} href={url}>
        <CardVideo autoPlay={autoPlay} story={story} aspectRatio={aspectRatio} imageType={imageType} widths={widths} />
      </Anchor>
      <NewsHeadline story={story} cssStyleName={cssStyleName} showSubHeading={showSubHeading} />
      <Excerpt excerpt={excerpt} url={url} />
      {sponsor ? (
        <SponsorDetails sponsorId={sponsor} showImage={false} />
      ) : (
        <StoryMetaData story={story} isPublished={showExcerpt} />
      )}
    </div>
  );
};

NewsWithVideo.propTypes = {
  story: object.isRequired,
  aspectRatio: array,
  imageType: string,
  widths: array,
  showSubHeading: bool,
  showExcerpt: bool,
  cssStyleName: string,
  autoPlay: number,
};

export default NewsWithVideo;
